import React, {useEffect, useState} from 'react';
import {Card, CardContent} from "@material-ui/core";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import RenderComponents from "./RenderComponents";
import {generateBorder} from "../../Utils/generateStyles";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";
import getParamsFromString from "../../Utils/getParamsFromString";

const CardScreenComponent = (props) => {
    const {element, basePath, containerArrayPath, actionsContext, doActions, globalValues, screenName} = props;
    const {events} = element;
    const [actions, setActions] = useState(null)
    const [customStyles, setCustomStyles] = useState({});

    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(element.styles, currentResolution);
    let adaptiveBorderRadius = typeof styles.borderRadius === 'object' ?
        styles.borderRadius[currentResolution] : styles.borderRadius;
    let borderObj = generateBorder(styles.border);
    const style = {
        margin: styles.margin,
        padding: 2,
        width: styles.width,
        height: styles.height,
        borderColor: styles.borderColor,
        cursor: actions ? 'pointer' : 'auto'
    };
    const cardStyle = {
        boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
        padding: styles.padding,
        background: styles.background,
        textAlign: styles.textAlign,
        minHeight: styles.minHeight,
        ...borderObj,
        borderRadius: adaptiveBorderRadius,
        height: '100%',
        overflow: 'auto'
    };

    useEffect(() => {
        if (element.events && element.events[0].event === 'onClick') {
            setActions(element.events[0].actions)
        }
    }, [])

    useEffect(() => {
        const styles = getStyles(globalValues, actionsContext);
        setCustomStyles(styles)
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext)]);

    function onClick() {
        if (actions) {
            doActions(actions, actionsContext);
        }
    }

    function getStyles() {
        const onLoad = (events || []).find(e => e.event === 'onLoad');
        if (onLoad) {
            const actions = onLoad.actions;
            const setStyles = (actions || []).find(e => e.type === 'setStyles');
            if (setStyles) {
                return getParamsFromString(setStyles.value, {...globalValues, ...actionsContext}, screenName);
            }
        }
    }

    return (
        <div style={style} onClick={onClick}>
            <Card style={{...cardStyle, ...customStyles}}>
                <CardContent
                    style={{
                        padding: 0,
                        height: "100%",
                        display: 'flex',
                        flexDirection: styles.flexDirection || 'column',
                        alignItems: styles.alignItems || 'baseline',
                        justifyContent: styles.justifyContent
                    }}
                >
                    {(element.children || []).map((element, index) => {
                        return (
                            <RenderComponents
                                key={element.id}
                                basePath={basePath}
                                element={element}
                                containerArrayPath={containerArrayPath}
                                actionsContext={actionsContext}
                            />
                        )
                    })}
                </CardContent>
            </Card>
        </div>
    );
};
export default JsonScreenHoc(CardScreenComponent);